import { useSelector } from 'react-redux'
import { Table } from '../../../../common/table'
import { DATA_TABLE } from './constant'
import { selectCellData, selectIds } from './store/slice'

export const BusinessStatusTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectIds)

  return (
    <Table
      ids={ids}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectCellData}
      schema={Object.values(DATA_TABLE).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          thStyle: item.thStyle,
          render: (val, { locale }) => {
            switch (item.key) {
              case DATA_TABLE.numberCompanies.key:
              case DATA_TABLE.totalPercentCompanies.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}
